import { useEffect } from 'react';
import { useAppSelector } from '../../../hooks';

import { selectConversationStatus } from 'reducers/workflows';
import ApiService from '../../../services/ApiService';

const useTracing = () => {
  const conversationStatus = useAppSelector(selectConversationStatus);

  useEffect(() => {
    if (conversationStatus === 'success') {
      ApiService.isTracingEnabled = true;
    }
  }, [conversationStatus]);
};

export default useTracing;
